module.exports = __webpack_public_path__ + "img/imgp8784.5ca7f590.jpg";